// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3w0Kz","name":"Header_name__1Knhh","birthday":"Header_birthday__hlE3s","skeleton":"Header_skeleton__3LDXg"};